<div class="or-d-flex or-flex-col">
  <span class="or-head-xs or-color-secondary-2 or-mb-2-px">Notatka (widoczna tylko dla adminów)</span>

  <textarea
    class="textarea-style or-w-100-pc or-p-8-px"
    rows="3"
    placeholder="Dlaczego nadajesz tę flagę?"
    (input)="setComment($event)"></textarea>
</div>
